module.exports = __webpack_public_path__ + "static/media/buffet20.51f394a9.jpg";